<template>
  <div  >
    <v-app-bar class="container"  fixed color="primary" dark elevation="7">
      <div class="toolbar-chido">
        <v-app-bar-nav-icon
          v-if="this.$store.state.sesion.logedInUserInfo != ''"
          @click.stop="muestraMenulateral()"
        ></v-app-bar-nav-icon>
      </div>
      <div class="d-flex align-center navbar-chido">
        <v-img
          alt="Primero Express Logo"
          contain
          class="shrink mr-2"
          src="../assets/PrimeroExpressLogo.png"
          transition="scale-transition"
          width="240"
        />
      </div>
     <!-- menus cargados de forma dinamica desde base de datos -->
      <div  v-for="(menu,index) in logedInUserInfo.menus" :key="index">
        <v-btn
          class="mr-2 navbar-chido"
          :to="menu.View"
          rounded
          color="blue darken-1"
          dark
          >{{menu.texto}}</v-btn
        >
      </div>
      <v-spacer></v-spacer>
      <v-menu v-if="$store.state.sesion.logedInUserInfo.id">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="navbar-chido" v-bind="attrs" v-on="on" rounded color="deep-purple" dark
            ><v-icon medium class="mr-2"> mdi-account </v-icon>{{ logedInUserInfo.nombre }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="cerrarSesion()">
            <v-list-item-title>Cerrar sesión</v-list-item-title>
          </v-list-item>
          <v-list-item @click="cambiarDatos()">
            <v-list-item-title>Cambiar contraseña</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <ModalCambioContrasena
        v-if="mostrarPreferenciasUsuario"
        :mostrarPreferenciasUsuario="mostrarPreferenciasUsuario"
        @ocultaModalCambiodeContrasena="ocultaModalCambiodeContrasena"
      />
    </v-app-bar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ModalCambioContrasena from "@/components/modales/ModalCambioContrasena.vue";

export default {
  name: "Navbar",
  data: () => ({
    drawer: true,
    mostrarPreferenciasUsuario: false
  }),
  components: {
    ModalCambioContrasena
  },
  methods: {
    ...mapActions("sesion", ["logOut"]),
    async cerrarSesion() {
      const objetoCierreSesion = new Object();
      objetoCierreSesion.Usuario = this.logedInUserInfo.usuario;
      objetoCierreSesion.RefreshTkn = this.logedInUserTokens.refreshToken;
      const res = await this.logOut(objetoCierreSesion);
      if (res) {
        this.$router.replace("login");
      } else {
      }
    },
    ocultaModalCambiodeContrasena() {
      this.mostrarPreferenciasUsuario = false;
    },
    muestraMenulateral() {
      this.$emit("muestraMenuLateralx");
    },
    cambiarDatos() {
      this.mostrarPreferenciasUsuario = true;
    }
  },
  computed: {
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo,
      logedInUserTokens: state => state.sesion.logedInUserTokens
    })
  }
};
</script>

<style lang="css" scoped>
/* Tamaño del scroll */
.container{
 overflow-x: auto;
 overflow-y: hidden;
 padding: 0px;
}
.container::-webkit-scrollbar {
  height: 6px;
}

 /* Estilos barra (thumb) de scroll */
.container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.container::-webkit-scrollbar-thumb:active {
  background-color: #999999;
}

.container::-webkit-scrollbar-thumb:hover {
  background: #b3b3b3;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}

 /* Estilos track de scroll */
.container::-webkit-scrollbar-track {
  background: #e1e1e1;
  border-radius: 4px;
}

.container::-webkit-scrollbar-track:hover,
.container::-webkit-scrollbar-track:active {
  background: #d4d4d4;
}

@media (max-width: 800px) {
  .navbar-chido {
    display: none;
  }
}
@media (min-width: 800px) {
  .toolbar-chido {
    display: none;
  }
}
</style>
